e4.favorites = {
    init: function () {
        if ( jQuery( '.js-e-product-favorite-list' ).length > 0 ) {
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorite-list' );
                e4.favorites.bindEvents();
            } );
        }
        else if ( jQuery( '.js-e-cart' ).length === 1 ) {
            jQuery( '.js-e-cart' ).on( 'loaded.e4.cart', function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorite-list' );
                e4.favorites.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        jQuery( document )
            .on( 'change', '.js-e-favorite-list-input', function ( event ) {
                e4.favorites.toggleList( event.target );
            } )
            .on( 'click', '.js-e-product-favorite-list-add-btn', function ( event ) {
                e4.favorites.createList( event.target );
            } )
            .on( 'shown.bs.collapse', '.js-e-product-favorite-list-add', e4.favorites.setListFocus )
            .on( 'show.bs.dropdown', '.js-e-product-favorite-list', e4.favorites.getListData )
            .on( 'hidden.bs.dropdown', '.js-e-product-favorite-list', e4.favorites.clearList );
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: e4.settings.ecom.favoritelists.url,
            dataType: 'json',
            method: 'GET',
            cache: false
        }, objAjaxSettings ) );
        jqXHR.done( function ( jsonData ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( jsonData );
            }
        } );
        jqXHR.fail( function ( data, textStatus, errorThrown ) {
            console.error( data, textStatus, errorThrown );
        } );
    },
    toggleList: function ( domInput ) {
        var jInput = jQuery( domInput );
        if ( jInput.prop( 'checked' ) === true ) {
            e4.favorites.addToList( jInput );
        }
        else {
            e4.favorites.removeFromList( jInput );
        }
    },
    addToList: function ( jInput ) {
        jInput.prop( 'disabled', true );
        e4.cc.ajax( {
            url: jInput.data( 'url-add' ) + '&Redirect=false'
        }, function () {
            jInput.prop( 'disabled', false );
        } );
    },
    removeFromList: function ( jInput ) {
        jInput.prop( 'disabled', true );
        e4.cc.ajax( {
            url: jInput.data( 'url-remove' ) + '&Redirect=false'
        }, function () {
            jInput.prop( 'disabled', false );
        } );
    },
    toggleNewList: function ( domElm ) {
        var jFavoriteList = jQuery( domElm ).closest( '.js-e-product-favorite-list' );
        jFavoriteList.find( '.js-e-product-favorite-list-add' ).collapse( 'toggle' );
    },
    addToNewList: function ( jListItems, jsonData ) {
        var jNewListInput = jListItems.find( '.js-e-favorite-list-input[data-list-id="' + jsonData.lastAdded.id + '"]' );
        jNewListInput.prop( 'checked', true );
        e4.favorites.toggleList( jNewListInput.get( 0 ) );
    },
    setListFocus: function ( event ) {
        jQuery( event.target ).find( '.js-e-product-favorite-list-form-add-name-input' ).trigger( 'focus' );
    },
    createList: function ( domElm ) {
        var jFavoriteList = jQuery( domElm ).closest( '.js-e-product-favorite-list' ),
            objProductDataSettings = jFavoriteList.data(),
            jListItems = jFavoriteList.find( '.js-e-product-favorite-list-items' ),
            jNameInput = jFavoriteList.find( '.js-e-product-favorite-list-add-name-input' ),
            strUrl = jFavoriteList.data( 'favoritesPage' ) + '&CC' + jFavoriteList.data( 'paragraphId' ) + '=CreateList';
        if ( jNameInput.val() !== '' ) {
            e4.favorites.ajax( {
                url: strUrl,
                method: 'POST',
                dataType: 'html',
                beforeSend: function () {
                    jFavoriteList.find( '.js-e-product-favorite-list-loader' ).addClass( 'is-loading' );
                },
                data: {
                    CC_Type: 'List',
                    CC_Name: jNameInput.val(),
                    Redirect: false
                }
            }, function () {
                jFavoriteList.find( '.js-e-product-favorite-list-loader' ).removeClass( 'is-loading' );
                e4.favorites.ajax( {
                    data: objProductDataSettings
                }, function ( jsonData ) {
                    e4.favorites.buildList( jListItems, jsonData );
                    e4.favorites.addToNewList( jListItems, jsonData );
                } );
                jNameInput.val( '' );
                jFavoriteList.find( '.js-e-product-favorite-list-add' ).collapse( 'hide' );
            } );
        }
        else {
            jNameInput.trigger( 'focus' );
        }
    },
    getListData: function ( event ) {
        var objProductDataSettings = jQuery( event.target ).data(),
            jListItems = jQuery( event.target ).find( '.js-e-product-favorite-list-items' );
        e4.favorites.ajax( {
            data: objProductDataSettings,
            beforeSend: function () {
                jQuery( event.target ).find( '.js-e-product-favorite-list-loader' ).addClass( 'is-loading' );
            }
        }, function ( jsonData ) {
            e4.favorites.buildList( jListItems, jsonData );
            jQuery( event.target ).find( '.js-e-product-favorite-list-loader' ).removeClass( 'is-loading' );
        } );
    },
    clearList: function ( event ) {
        jQuery( event.target ).find( '.js-e-product-favorite-list-items' ).html( '' );
    },
    buildList: function ( jListItems, jsonData ) {
        jListItems.html( e4.handlebars.tmpl.favoriteList( jsonData ) );
    }
};
